export const VERIFICATION_CODE_LIFE_MINUTES = 10;
